import type { FilterChip } from '../FilterChips/FilterChips'
import type { FilterSelectSpec, FilterTextSpec } from './FilterBar'

export function chipsOf(
  search: string,
  searchLabel: string,
  selects: FilterSelectSpec[],
  texts: FilterTextSpec[],
): FilterChip[] {
  const chosen = selects.flatMap((select) => {
    const option = select.options.find((entry) => entry.value === select.value)

    return option === undefined
      ? []
      : [{ name: select.name, label: select.label, value: option.label }]
  })
  const typed = texts.flatMap((text) =>
    text.value === '' ? [] : [{ name: text.name, label: text.label, value: text.value }],
  )

  return [
    ...(search === '' ? [] : [{ name: 'search', label: searchLabel, value: search }]),
    ...typed,
    ...chosen,
  ]
}
